<template>
  <div :style="themeStyle" height="100%" >
    <!-- <v-row class="headline1_bg p-3" no-gutters>
      <v-col cols="12"> ของรางวัล </v-col>
    </v-row> -->
    <v-container class="pt-5" v-if="!item" height="50%">
       <v-skeleton-loader height="50vh"
          type="card"
        ></v-skeleton-loader>
    </v-container>
    <div v-if="item" height="100%">
      <!-- <h1>socket Example with Vue.js</h1>
      <v-btn @click="sendMessage">Send Message</v-btn> -->
      <div class="mx-auto rounded-lg" elevation="2" height="100%">
        <v-img class="white--text align-end" :src="item.pictureUrl">
          <div
            v-if="item.quotaCode <= 0"
            style="
              position: absolute;
              left: 0px;
              top: 45px;
              text-align: center;
              color: #fff;
              background-color: red;
              width: 100px;
              border-style: solid;
              border-color: #fff;
              border-width: 2px;
              border-left-style: none;
            "
          >
          {{ $t("message.outStock") }}
          </div>
          <v-chip
            class="ma-2"
            color="white"
            style="position: absolute; bottom: 20px; right: 5px"
            :style="$isTargetShop ?' background-color: #FFD000 !important' : '' "
          >
            <img
                  v-if="profile.pictureUrl && !$isTargetShop()"
                  style="
                    border-color: white;
                    height: 20px;
                    margin-right: 4px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                />
            <img
                v-else
                style="
                  border-color: white;
                  height: 20px;
                  margin-right: 4px;
                "
                alt="Avatar"
                :src="require('@/assets/Vector.svg')"
              />
            <div v-if="item.supply !== 'admin'">
              <div v-if="item.resale && item.resale > 0">
                <strong v-if="item.resale" class="text-center"
                    >{{item.resale}}
                </strong>
                <strong class="text-center" color="#181446" style="text-decoration: line-through;color: grey;margin-left: 4px;font-size: 13px;"
                  >{{ 'formatNumber(item.point)' }}
                </strong>
              </div>
              <div v-else>
                <strong class="text-center" color="#181446"
                  >{{ formatNumber(item.point) }}
                </strong>
              </div>
            </div>
            <div v-else>
              <strong class="text-center" color="#181446"
                >{{ findPointToRedeem(item.levelSettingsReward) }}
              </strong>
            </div>
          </v-chip>
        </v-img>
        <v-container fluid>
          <v-row v-if="$i18n.locale === 'th' || item.nameEng === '' || item.nameEng === null">
            <v-col class="bold font18">{{ item.name }}</v-col>
          </v-row>
          <v-row v-if="$i18n.locale === 'en' && item.nameEng !== null && item.nameEng !== ''">
            <v-col class="bold font18">{{ item.nameEng }}</v-col>
          </v-row>
          <v-row>
            <v-chip class="ma-2" color="orange" text-color="white" small v-if="item.supply !== 'admin'">
              {{ item.levelNm ?  item.levelNm : item.levelId }}
              <v-icon right small> mdi-star </v-icon>
            </v-chip>
            <v-chip class="ma-2" color="orange" text-color="white" small>
              <div v-if="item.supply === 'จัดส่ง'">{{ $t("message.delivery") }}</div>
              <div v-if="item.supply === 'รับหน้าร้าน'">{{ item.shopId === 'U2ad4ca7a5c84fbe7358b56f54af919fa' ? 'รับที่สำนักงานโครงการ' : $t("message.ReceiveAtStore") }}</div>
              <div v-if="item.supply === 'link_code'">{{ item.supply }}</div>
              <div v-if="item.supply === 'admin'">{{ item.supply }}</div>
              <!-- {{ (item.supply === 'จัดส่ง' ? {{ $t("message.inventories") }} : ) }} -->
              <v-icon right small>
                {{
                  item.supply === "จัดส่ง"
                    ? "mdi-cube-send"
                    : item.supply === "รับหน้าร้าน"
                    ? "mdi-store"
                    : item.supply === "link_code"
                    ? "mdi-barcode-scan"
                    : "mdi-comment-account"
                }}
              </v-icon>
            </v-chip>
            <v-chip class="ma-2" color="orange" text-color="white" small>
              {{ $t("message.inventories") }} <p style="margin-bottom:0px;padding-left:5px">{{ item.quotaCode }}</p>
            </v-chip>
            <v-chip class="ma-2" color="orange" text-color="white" small>
              {{ $t("message.visiter") }} <p style="margin-bottom:0px;padding-left:5px">{{ item.countView }}</p>
              <v-icon right small>mdi-eye</v-icon>
            </v-chip>
          </v-row>
          <v-row v-if="item.description && $i18n.locale === 'th' || item.descriptionEng === '' || item.descriptionEng === null">
            <v-col class="icon2 font14"
              ><nl2br tag="p" :text="item.description"
            /></v-col>
          </v-row>
          <v-row v-if="item.descriptionEng && $i18n.locale === 'en'">
            <v-col class="icon2 font14"
              ><nl2br tag="p" :text="item.descriptionEng"
            /></v-col>
          </v-row>
        </v-container>

        <div class="px-5" style="margin-bottom: 20px;">
          <v-btn
            v-if="item.quotaCode > 0"
            class="rounded-md"
            :color='$bgColor'
            :disabled="item.supply === 'admin'"
            :style="'color:' + $textcolor"
            dark
            block
            :loading="load"
            @click="checkLevelAndCoin()"
          >
          {{ $t("message.redeemReward") }}
          </v-btn>
          <v-btn
            v-if="item.quotaCode <= 0"
            disabled
            class="rounded-lg headline1"
            rounded
            block
            @click="checkLevelAndCoin()"
          >
          {{ $t("message.outStock") }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
// import axios from 'axios'

// import io from 'socket.io-client'

export default {
  name: 'RewardDetail',
  sockets: {
    connect () {
    }
  },
  data () {
    return {
      id: this.$route.params.id,
      item: null,
      // socket: io(),
      member: null,
      profile: null,
      message: null,
      msgList: [],
      msg: '',
      isConnected: null,
      load: false,
      shopData: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    // this.isConnected = this.$socket.connected
    // // console.log('v', this.$socket.client.emit('ddddddd'))
    // try {
    //   this.$socket.client.emit('ddddddd', 'Hello from Vue.js!')
    // } catch (err) {
    //   console.log('1000000', err)
    // }
    // let aa = this.$socket.client.on('message_from_server111')
    // console.log(aa)
    window.scrollTo(0, 0)
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.getReward()
    await this.transactionVisitPage()
    // this.setupSSE()
    // this.WebSocket1()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    // WebSocket1 () {
    //   console.log('dddd')
    //   let a = this.$socket.client.emit('message_from_client', 'Hello from Vue.js!')
    //   console.log(a)
    // },
    // sendMessage () {
    //   try {
    //     this.$socket.client.emit('message_from_client', 'test')
    //   } catch (error) {
    //     console.log(error)
    //   }
    //   console.log('aaaaa')
    // },
    // setupSSE () {
    //   const eventSource = new EventSource(this.DNS_IP + `/events`)
    //   console.log('eventSource', eventSource)
    //   eventSource.onmessage = (event) => {
    //     const data = event.data
    //     console.log('eventSource', data)
    //     this.message = data
    //     if (data === 'END') {
    //       // ปิดการเชื่อมต่อ SSE
    //       eventSource.close()
    //       console.log('Connection closed.')
    //     } else {
    //       // ประมวลผลข้อมูลที่ได้รับ
    //       console.log('Received data:', data)
    //     }
    //   }
    // },
    // this.getMemberProfile()
    findPointToRedeem (item) {
      try {
        const levelSettings = JSON.parse(item)
        if (Array.isArray(levelSettings)) {
          const matched = levelSettings.find(data =>
            data.levelId.toString() === this.member.levelId && data.enabled === true
          )
          return matched ? matched.points : null
        }

        return null
      } catch (error) {
        console.error('findPointToRedeem error', error)
      }
    },
    async checkLevelAndCoin () {
      if (this.item.levelNm === 'All Level') {
        if (this.member.currentPoint >= this.item.point) {
          if (this.item.supply === 'จัดส่ง') {
            this.$router.push(`/reward/addAddress/${this.item.rewardId}`)
          } else {
            this.load = await this.redeemReward(this.item)
            this.member = this.GET_MEMBERINFO()
          }
        } else if (this.member.currentPoint < this.item.point) {
          // await this.redeemReward(this.item)
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonColor: '#6ECB63',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          })
          Toast.fire({
            icon: 'error',
            width: 3000,
            title: 'คะแนน ของคุณไม่พอ  :( ',
            html: 'คุณต้องการไป ดูเงื่อนไขรับคะแนนหรือไม่ ?',
            backdrop: `rgba(0,0,001,0.4)`
          }).then((confirm) => {
            if (confirm.isConfirmed) {
              this.$router.push('/HowToGetCoin')
            } else {
              this.load = false
            }
          })
        }
      } else if (this.item.levelNm !== 'All Level') {
        // console.log(' not All Level', this.item)
        // console.log('this.member', this.member)
        if (this.member.levelPoint >= this.item.levelPoint) {
          // console.log('true')
          if (this.member.currentPoint >= this.item.point) {
            // console.log('เเลกได้ 8ss')
            if (this.item.supply === 'จัดส่ง') {
              this.$router.push(`/reward/addAddress/${this.item.rewardId}`)
            } else {
              this.load = await this.redeemReward(this.item)
              this.member = this.GET_MEMBERINFO()
            }
          } else if (this.member.currentPoint < this.item.point) {
            const Toast = Swal.mixin({
              toast: true,
              position: 'center',
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonColor: '#6ECB63',
              confirmButtonText: 'ยืนยัน',
              cancelButtonText: 'ยกเลิก'
            })
            Toast.fire({
              icon: 'error',
              width: 3000,
              title: 'คะแนน ของคุณไม่พอ  :( ',
              html: 'คุณต้องการไป ดูเงื่อนไขรับคะแนนหรือไม่ ?',
              backdrop: `rgba(0,0,001,0.4)`
            }).then((confirm) => {
              if (confirm.isConfirmed) {
                this.$router.push('/HowToGetCoin')
              } else {
                this.load = false
              }
            })
          }
        } else if (this.member.levelPoint < this.item.levelPoint) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: true,
            confirmButtonColor: '#6ECB63',
            confirmButtonText: 'ตกลง'
          })
          Toast.fire({
            icon: 'error',
            width: 3000,
            title: 'ระดับบัตรสมาชิกไม่พอ :(',
            html:
              'สามารถเเลกได้เฉพาะ member ที่มีเลเวล ' +
              this.item.levelNm +
              ' ขึ้นไปเท่านั้น',
            backdrop: `rgba(0,0,001,0.4)`
          }).then((confirm) => {
            if (confirm.isConfirmed) {
              this.$router.push('/tierBenefit')
            }
          })
        }
      }
    },
    async getReward () {
      const result = await this.callBeTaskAPI(
        'get',
        `/reward/getColor?rewardId=${this.id}`
      )
      if (result) {
        this.item = result[0]
      }
    },
    async transactionVisitPage () {
      const result = await this.callBeTaskAPI(
        'post',
        `/TransactionVisitPage/add`, {
          page: 'Reward Detail',
          rewardId: this.id,
          shopId: this.member.shopId,
          CREATE_USER: this.member.lineUserId
        }
      )
      if (result) {
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reward/Detail.vue